module.exports = __webpack_public_path__ + "8-o1.jpg?f6dfb8328da098f37bb8112299824b92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/8-o1.jpg
// module id = 662
// module chunks = 0